import React from 'react';
/**
 * PracticeView — Full-screen practice session rendering
 *
 * Extracted from App.tsx in R33 (DDD Fase 6 — App Shell decomposition).
 * Renders the PracticeSession with error boundary, handling both
 * regular practice and assessment modes.
 */
import { PracticeSession, PracticeErrorBoundary } from '../practice';
import type { ModuleId, Question } from '../content';
interface PracticeViewProps {
  activeModuleId: ModuleId | null;
  activeModeId?: string | null;
  isFocusSession: boolean;
  focusQuestions: Question[];
  isAssessmentMode: boolean;
  cheatSheetViewed: boolean;
  pendingLevelUp: number | null;
  xp: number;
  onComplete: () => void;
  onExit: () => void;
  onAnswer: (questionId: string, isCorrect: boolean, userChoice: number, payload?: string, errorType?: string, delta?: number) => void;
  onCheatSheetView: () => void;
  onClearPendingLevelUp: () => void;
  onReset: () => void;
}
export function PracticeView({
  activeModuleId,
  activeModeId,
  isFocusSession,
  focusQuestions,
  isAssessmentMode,
  cheatSheetViewed,
  pendingLevelUp,
  xp,
  onComplete,
  onExit,
  onAnswer,
  onCheatSheetView,
  onClearPendingLevelUp,
  onReset
}: PracticeViewProps) {
  return <>
      <PracticeErrorBoundary onReset={onReset} data-id="element-810">
        <PracticeSession moduleId={activeModuleId} questions={isFocusSession ? focusQuestions : []} onComplete={onComplete} onExit={onExit} onAnswer={onAnswer} cheatSheetViewed={cheatSheetViewed} onCheatSheetView={onCheatSheetView} isCrossModule={isFocusSession} mode={isAssessmentMode ? 'assessment' : 'practice'} isFluency={activeModeId === 'fluency'} labMode={activeModeId ?? undefined} pendingLevelUp={pendingLevelUp} xp={xp} onClearPendingLevelUp={onClearPendingLevelUp} data-id="element-811" />
      </PracticeErrorBoundary>
    </>;
}